var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcSoup(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.818,
    height: 34.031,
    viewBox: "0 0 30.818 34.031",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.033)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.049 19.114)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.153,2.827a4.934,4.934,0,0,0-.636-.537A14.335,14.335,0,0,1,2.249,0H0A14.335,14.335,0,0,0,.269,2.29,4.934,4.934,0,0,1,.9,2.827a1.782,1.782,0,0,0,1.374.682A1.536,1.536,0,0,0,3.4,3.059c-.081-.072-.163-.149-.25-.232Z",
    transform: "translate(0.042 0.033)",
    fill: "#fc8e56",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.125,1.654c.052,0,.1,0,.152,0A2.522,2.522,0,0,1,2.2,1.436,3.627,3.627,0,0,0,3.223.682C3.31.6,3.391.522,3.473.45A1.536,1.536,0,0,0,2.348,0,1.783,1.783,0,0,0,.974.682,3.733,3.733,0,0,1,0,1.412,2.559,2.559,0,0,0,1.125,1.654Z",
    transform: "translate(3.445 2.937)",
    fill: "#fc8e56",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.376.355a2.666,2.666,0,0,1-.843.129A2.511,2.511,0,0,1,0,0,14.27,14.27,0,0,0,.694,1.685a1.467,1.467,0,0,0,.839.23,1.64,1.64,0,0,0,1.252-.567Q2.562.861,2.376.355Z",
    transform: "translate(0.788 4.107)",
    fill: "#fc8e56",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.249,1.651c.043,0,.087,0,.131,0a2.805,2.805,0,0,0,2.1-.972c.087-.082.169-.16.25-.232A1.536,1.536,0,0,0,3.6,0,1.783,1.783,0,0,0,2.229.682a2.805,2.805,0,0,1-2.1.972c-.044,0-.088,0-.131,0a14.362,14.362,0,0,0,12.2,6.8q.572,0,1.133-.045A14.372,14.372,0,0,1,2.249,1.651Z",
    transform: "translate(2.189 5.418)",
    fill: "#fc8e56",
    opacity: 0.4
  })), /*#__PURE__*/React.createElement("path", {
    d: "M3.661,9.319A3.7,3.7,0,0,1,.467,7.459,3.32,3.32,0,0,1,.446,4.1c.009-.014.018-.029.028-.042L3.232.219a.525.525,0,0,1,.852,0L6.847,4.063a.311.311,0,0,1,.026.041,3.3,3.3,0,0,1-.012,3.347,3.7,3.7,0,0,1-3.2,1.868Z",
    transform: "translate(16.835 7.872)",
    fill: "#d84a4a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.289,10.972A4.334,4.334,0,0,1,.546,8.794,3.877,3.877,0,0,1,.522,4.866a.338.338,0,0,1,.027-.042L3.858.219a.525.525,0,0,1,.852,0L8.026,4.832a.317.317,0,0,1,.027.041,3.859,3.859,0,0,1-.015,3.911,4.336,4.336,0,0,1-3.747,2.188Z",
    transform: "translate(8.857 0)",
    fill: "#d84a4a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.649,7.455a.51.51,0,0,1-.066-.133A15.307,15.307,0,0,1,0,.525.525.525,0,0,1,.525,0H30.293a.525.525,0,0,1,.525.525,15.329,15.329,0,0,1-1.247,6.069.5.5,0,0,1-.056.127,15.431,15.431,0,0,1-14.107,9.213A15.425,15.425,0,0,1,1.649,7.455Z",
    transform: "translate(0.033 18.097)",
    fill: "#425966"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSoup);
export default __webpack_public_path__ + "static/media/ic_soup.e654cc6d794245907ac9adca3367e174.svg";
export { ForwardRef as ReactComponent };